import { Icon } from "../../Components/Chip/Chip.tsx";
import { IMedia } from "../../Components/MediaCarousel/MediaCarousel";

export interface ILink {
  displayText: string;
  url: string;
  icon?: Icon;
}

export interface IProjectData {
  id: number;
  mediaList: IMedia[];
  longDescription: string;
  links: ILink[];
  title: string;
  technologies: string[];
  thumbnail: string;
  shortDescription: string;
}

export const ProjectData: IProjectData[] = [
  {
    id: 13,
    mediaList: [
      {
        type: "IMAGE",
        url: "https://i.imgur.com/tK54LqC.png",
        caption: "MVP roadmap screen Mockup",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/JUATZp3.png",
        caption: "Customer Segmentation",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/O6EB1Wl.png",
        caption: "Discovery Interview Findings",
      },
    ],
    links: [
      {
        displayText: "Figma Mockup",
        url: "https://www.figma.com/proto/YqVRnn8p1EJSLGX5YaVd4R/Leap?node-id=156-245&t=26IZ0rrOEAOYJIzv-1&starting-point-node-id=103%3A2740",
        icon: Icon.WEBSITE,
      },
      {
        displayText: "LinkedIn",
        url: "https://www.linkedin.com/company/106384710",
        icon: Icon.linkedin,
      },
      {
        displayText: "Instagram",
        url: "https://www.figma.com/proto/YqVRnn8p1EJSLGX5YaVd4R/Leap?node-id=156-245&t=26IZ0rrOEAOYJIzv-1&starting-point-node-id=103%3A2740",
        icon: Icon.instagram,
      },
    ],
    title: "Leap",
    technologies: [
      "Entrepreneurship",
      "Azure AI",
      "React Native",
      "SupaBase",
      "PostgreSQL",
      "Expo",
      "Project Management",
      "TypeScript",
    ],
    shortDescription: "An AI-powered app to help university students acheive their goals.",
    longDescription:
      "Created by 4 UBC students as part of Innovation UBC's Venture Founder program.  For university students balancing goals, who are motivated by community support and struggle with time management, Leap is a productivity tool that breaks goals down into actionable tasks, helps prioritize deadlines, and fosters motivation through community accountability.",
    thumbnail: "https://i.imgur.com/IcpFJYV.png",
  },
  {
    id: 12,
    mediaList: [
      {
        type: "VIDEO",
        url: "https://www.youtube.com/embed/vsojg1SqYhc?si=RFfLj4tJkhJEyO4t",
        caption: "AlgoBytes preview video",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/RSjK2II.png",
        caption: "Course Roadmap",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/2AiqYCI.png",
        caption: "Streaks Screen",
      },
    ],
    links: [
      {
        displayText: "AlgoBytes Website",
        url: "https://algobytes.app",
        icon: Icon.WEBSITE,
      },
    ],
    title: "AlgoBytes",
    technologies: ["React Native", "SupaBase", "PostgreSQL", "Expo", "Project Management", "TypeScript", "HTML/CSS"],
    shortDescription: "A Duolingo-inspired mobile app created to teach solving coding problems",
    longDescription:
      "A Duolingo-inspired mobile app created to teach solving coding problems.  This app was developed using React Native and SupaBase and works on both Android and iOS.  The goal of this app was to lower the barrier to entry for leetcode, which can be daunting as you might sit in front of a problem for 30 minutes wihtout knowing what to do.  By leveraging learning over time and repition, we aim to help people master the intuition behind solving programming problems.",
    thumbnail: "https://i.imgur.com/3rceaAm.png",
  },
  {
    id: 1,
    mediaList: [
      {
        type: "VIDEO",
        url: "https://www.youtube.com/embed/WDbJ2VZBBPE?si=HopuoTYAl4i2yxu7",
        caption: "Version 1.6 Release Notes Video",
      },
      {
        type: "VIDEO",
        url: "https://youtube.com/embed/OhG_MD-7fWA",
        caption: "YouTube video for the Workday Chrome Extension",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/RTYmrt9.png",
        caption: "Picture of Workday with the Chrome Extension",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/TK9QL6D.png",
        caption: "Popup information for selected course",
      },
      // {
      //   type: "IMAGE",
      //   url: "https://i.imgur.com/SKon7hA.png",
      //   caption: "Close-up Image of the etension",
      // },
    ],
    links: [
      {
        displayText: "Chrome Web Store",
        url: "https://chromewebstore.google.com/detail/ubc-workday-side-by-side/gonljejijjjmjccdbjokcmmdfmlincmh?hl=en",
        icon: Icon.WEBSITE,
      },
      {
        displayText: "GitHub",
        url: "https://github.com/mlool/workday-calendar-extension",
        icon: Icon.github,
      },
    ],
    title: "UBC Workday Chrome Extension",
    technologies: ["React", "Project Management", "TypeScript", "HTML/CSS", "Bussiness Development", "APIs"],
    shortDescription:
      "A Chrome Extension created to combat Workday's poor UI/UX.  Over 5000 active users and a growing community.",
    longDescription:
      "A Chrome Extension created to combat Workday's poor UI/UX, attracting over 5000 users and a very active discord community!  Adds a handy calendar on the side of Workday.  Very useful for registering courses as there is now an easy way to see time conflicts in Workday.   Open source project maintained by a small group of developers.  The extension is created using REACT and Typescript and CSS.  Data from RateMyProf, and UBC Grades, two very popular websites for students to judge whether or not to take a course, has been integrated into the extension using APIs, greatly improving the course registration efficiency of students. ",
    thumbnail: "https://i.imgur.com/PTkQMxK.png",
  },
  {
    id: 2,
    mediaList: [
      {
        type: "VIDEO",
        url: "https://www.youtube.com/embed/MIYOK05I0uc?si=WPDKa8cSp830u83M",
        caption: "YouTube demo of ItinerAI",
      },
      {
        type: "IMAGE",
        url: "https://d112y698adiu2z.cloudfront.net/photos/production/software_photos/002/933/555/datas/gallery.jpg",
        caption: "Picture of the Website",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/MufjQrp.png",
        caption: "Backend Diagram",
      },
    ],
    links: [
      {
        displayText: "Hackathon Page",
        url: "https://devpost.com/software/itinerai",
        icon: Icon.WEBSITE,
      },
    ],
    title: "ItinerAI - Microsoft AI Hackathon (Top 10)",
    technologies: [
      "Azure",
      "Python",
      "Machine Learning",
      "React",
      "Docker",
      "Github Actions",
      "CI/CD Workflow",
      "DevOps",
    ],
    shortDescription:
      "A travel app with integrated custom chatbot to create itineraries.  Made with friends for a Microsoft Hackathon (Top 10 Project)",
    longDescription:
      "ItinerAI is a web app designed to make trip planning easier.  We created a custom chabot using Azure's Open AI which can query an Azure Cosmos DB using vector searches to find related locations.  Our app provides a seamless experience by allowing you to effortlessly view your itinerary items on an interactive map, complete with directions. With the help of our intelligent chatbot, you can receive personalized location suggestions and easily add new destinations to your itinerary. Additionally, you have the flexibility to manually rearrange and edit locations, ensuring your travel plans are perfectly tailored to your preferences. This integration makes your journey both enjoyable and efficient, giving you full control over your itinerary with ease.",
    thumbnail: "https://i.imgur.com/xhePixJ.png",
  },
  {
    id: 3,
    mediaList: [
      {
        type: "IMAGE",
        url: "https://i.imgur.com/ISZUIzO.png",
        caption: "UBC Student Hub Homepage",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/Bo89jbc.png",
        caption: "A Social Page for Students to Promote Projects or Ask Questions",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/i6Myn65.png",
        caption: "Profile View of a Student Logged In to the Current Account",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/K9WhnWj.png",
        caption: "Profile View of a Different Student",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/5SkvsuY.png",
        caption: "Login Page",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/0agkBFE.png",
        caption: "Research Page for Course Information (Made by Jaskirat Gill)",
      },
    ],
    links: [
      {
        displayText: "UBC Student Hub",
        url: "https://ubcstudenthub.ca",
        icon: Icon.WEBSITE,
      },
    ],
    title: "UBC Student Hub",
    technologies: [
      "React",
      "Project Management",
      "Google Firebase",
      "Dynamo DB",
      "Bussiness Development",
      "Material UI",
      "Software Design",
    ],
    shortDescription: "A one-stop shop for UBC students featuring course planning and social experiences.",
    longDescription:
      "A followup project to the UBC Workday Chrome Extension, intended to be a place where students can go for more in depth information and features.  Currently we support a calendar view of courses, with schedules being synced from the extension, directions from Google Maps between courses, and a user / social system.  I am responsible for the user authentication and social system, designing and implementing both.  I created a system where users can post questions and interact with other users.  Users can comment and even like other people's posts, fostering a collaborative environment between students.  Users are also able to create accounts using their email and password, which was implemented using Google Firebase's authentication API.",
    thumbnail: "https://i.imgur.com/5kzhdhM.png",
  },
  {
    id: 4,
    mediaList: [
      {
        type: "VIDEO",
        url: "https://www.youtube.com/embed/CR8y_MwBNoA?si=diskfUWDRKbZovz-",
        caption: "Gameplay trailer of the boss fight",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/yS9S4JX.png",
        caption: "Warehouse level (level 1) sprites",
      },
    ],
    links: [
      {
        displayText: "Github",
        url: "https://github.com/StashC/BadBlood",
        icon: Icon.github,
      },
    ],
    title: "Bad Blood",
    technologies: ["Unity", "C#", "Game Design", "State Machines", "Project Management", "Adobe Photoshop"],
    shortDescription: "A 2D platformer game prototype created by team 9 for the UBC GameDev Club",
    longDescription:
      "You play as a vampire who was fired from their job, and decides to take revenge on their former boss. You work your way up through the company, starting off fighting in the warehouse, moving up to the offices, and finally to the executive floor where you meet your former boss. Vampire hunter Geoffery Bezhaust. Prototype Features: 2 different types of enemies, enemy brutes with a charge attack and ranged enemies. Geoffery Bezhaust, the enemy boss, featuring lightning strike attacks, money bag bombs, and a coin gun. Civilians which flee from the player. Blood particle health pickups. Player can enter `Batmode`, a swarm of bats allows him to float around.  The particle effects were created using Unity's particle system, and the AI behaviour was implemented using state machine designs, including the boss, Geoffery Bezhaust.",
    thumbnail: "https://i.imgur.com/5ZmBiNr.png",
  },
  {
    id: 6,
    mediaList: [
      {
        type: "VIDEO",
        url: "https://www.youtube.com/embed/huOZqGP94JY?si=zqzp8OrW2pSOGVm7",
        caption: "Youtube Demo",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/ESmpsNF.png",
        caption: "Picture of DFS Generated Maze",
      },
      {
        type: "IMAGE",
        url: "https://i.imgur.com/h07saIA.png",
        caption: "Picture of a User-drawn Maze",
      },
    ],
    links: [
      {
        displayText: "GitHub",
        url: "https://github.com/StashC/PathfindingDemo",
        icon: Icon.github,
      },
    ],
    title: "Interactive Maze Generator and Solver",
    technologies: ["Unity", "C#", "Data Structure & Algorithms", "AStar Pathfinding"],
    shortDescription: "An interactive maze generator and solver simulation created with Unity.",
    longDescription:
      "An interactive pathfinding simulation implementing the A* pathfinding algorithm.  The simulation will find the shortest path between two points.  The user can select a start and end point, place barriers, or even have a maze generate for them.  Mazes are generated using a Depth First search algorithm, which I created after researching maze generating algorithms on wikipedia.  I was inspired by Sebastian Lague's youtube demo of Astar, and other pathfinding algorithms, so I decided to challenge myself and create one in Unity. ",
    thumbnail: "https://i.imgur.com/XaJNe7W.png",
  },
  {
    id: 5,
    mediaList: [
      {
        type: "VIDEO",
        url: "https://www.youtube.com/embed/jjA8-Bt7kyI?si=_krGrYhTzApG92vj",
        caption: "Video Gameplay Demo",
      },
      {
        type: "IMAGE",
        url: "https://user-images.githubusercontent.com/89222842/169706361-704ac905-502d-4a1d-b550-7f3210375979.png",
        caption: "Picture of the game",
      },
      {
        type: "IMAGE",
        url: "https://user-images.githubusercontent.com/89222842/169706366-9099ad91-ac62-4e66-83a9-0dd2fde57bf5.png",
        caption: "Custom shop UI",
      },
      {
        type: "IMAGE",
        url: "https://user-images.githubusercontent.com/89222842/169706487-86e326fb-19f1-40ff-8ec1-11d62836486a.png",
        caption: "Animated main menu screen",
      },
    ],
    links: [
      {
        displayText: "Github",
        url: "https://github.com/StashC/Space-Survival-Game",
        icon: Icon.github,
      },
    ],
    title: "Space Survival Game",
    technologies: ["Unity", "C#", "Game Dev"],
    shortDescription:
      "A 2D video game made from scratch in Unity using C# for my grade 10 personal project winning first place in my high school.",
    longDescription:
      "A game I made in Grade 10 for my high school passion project, recieving first place in my school's project fair. I spent 5 months creating a videogame and documenting the process for my IB Middle Years Program personal project. This game was inspired by Brackey's 2d Game Development series on YouTube.  All of the game assets were created using Adobe PhotoShop",
    thumbnail: "https://i.imgur.com/R9ZLXPV.png",
  },
];
